const advantages = [
  "Fully-alarmed, secure indoor facility",
  "Two Bay Area locations — San Rafael &amp; Point Richmond",
  "65+ years of trusted automotive experience",
  "Best rates for long-term seasonal storage",
  "Designed for high-value and collectible vehicles",
  "Motorcycle transport &amp; road service available",
];

export default function WhyChooseUs() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="bg-charcoal-DEFAULT overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {/* Left Image */}
        <div className="relative h-72 lg:h-auto order-last lg:order-first">
          <img
            src="https://public.readdy.ai/ai/img_res/41fa56a3aa26f2bd1e7fbb6a63ff1e90.jpg"
            alt="Premium indoor vehicle storage facility interior"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-charcoal-DEFAULT/60"></div>
        </div>

        {/* Right Content */}
        <div className="bg-charcoal-DEFAULT flex items-center px-10 lg:px-16 py-16 lg:py-24 relative">
          {/* Gold vertical bar */}
          <div className="absolute left-0 top-16 bottom-16 w-1 bg-gradient-to-b from-transparent via-gold to-transparent"></div>

          <div className="w-full">
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
              Advantages
            </p>
            <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold mb-8 leading-tight">
              Why Choose
              <br />
              <span className="text-gold">Premium Protection</span>
            </h2>

            <ul className="space-y-5 mb-10">
              {advantages.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-gold text-lg"></i>
                  </div>
                  <span
                    className="font-sans text-[#C8C8C8] text-base leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </li>
              ))}
            </ul>

            <button
              onClick={() => handleScroll("#contact")}
              className="font-sans text-sm font-semibold bg-gold text-charcoal px-8 py-4 rounded tracking-wide hover:bg-gold-light transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Request Availability
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
